export enum MedicationAdministrationStatusEnum {
  ADMINISTERED = "administered",
  SKIPPED = "skipped",
  NONE = "none",
  SELF_ADMINISTERED = "self_administered",
  VOIDED = "voided",
}

export const statusToColourClassMap = {
  [MedicationAdministrationStatusEnum.ADMINISTERED]: "text-success-600",
  [MedicationAdministrationStatusEnum.SKIPPED]: "text-warning-600",
  [MedicationAdministrationStatusEnum.VOIDED]: "text-red-600",
  [MedicationAdministrationStatusEnum.NONE]: "text-gray-600",
  [MedicationAdministrationStatusEnum.SELF_ADMINISTERED]: "text-gray-600",
};
